import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import logoSrc from "@/assets/logococo.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandLogo',
  props: {
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md", "lg"].includes(value),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(logoSrc),
    alt: "CocoUni",
    class: _normalizeClass(["brand-logo", `brand-logo--${__props.size}`])
  }, null, 10, _hoisted_1))
}
}

})